import { render, staticRenderFns } from "./CustomerLoginForm.vue?vue&type=template&id=78d055d6"
import script from "./CustomerLoginForm.vue?vue&type=script&lang=js"
export * from "./CustomerLoginForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports